import { Order } from 'gql/types';
import { TFunction } from 'i18next';
import moment from 'moment';
import { formatPhoneNumber, mapPickupLocationToString } from 'utils';
import { chain } from 'lodash';

export const mapOrdersToCsvData = (orders: Order[], t: TFunction) => {
  return chain(orders)
    .orderBy(
      ['pickupDate', 'pickupLocation.priority', 'pickupLocation.name'],
      ['asc', 'desc', 'asc']
    )
    .map(
      (
        { amount, pickupLocation, purchaser, totalPrice, pickupDate, comments },
        index
      ) => ({
        // eslint-disable-next-line
        ['Lp.']: index + 1,
        [t('labels:purchaser')]: `${purchaser.name}`,
        [t('labels:pickupLocation')]: mapPickupLocationToString(
          true,
          pickupLocation
        ),
        [t('labels:amount')]: `${amount}`,
        [t('labels:pickupDate')]: moment(parseInt(pickupDate, 10)).format(
          'DD.MM.YYYY'
        ),
        [t('labels:contact')]: formatPhoneNumber(purchaser.phoneNumber),
        [t('labels:totalPrice')]: `${totalPrice}`,
        [t('labels:comments')]: `${comments}`,
      })
    )
    .value();
};
